import { render, staticRenderFns } from "./TariffDgoItem.vue?vue&type=template&id=70bb313e&scoped=true&"
import script from "./TariffDgoItem.vue?vue&type=script&lang=ts&"
export * from "./TariffDgoItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffDgoItem.vue?vue&type=style&index=0&id=70bb313e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb313e",
  null
  
)

export default component.exports